import { render, staticRenderFns } from "./BasWarehouseList.vue?vue&type=template&id=d38b52ea&scoped=true&"
import script from "./BasWarehouseList.vue?vue&type=script&lang=js&"
export * from "./BasWarehouseList.vue?vue&type=script&lang=js&"
import style0 from "./BasWarehouseList.vue?vue&type=style&index=0&id=d38b52ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38b52ea",
  null
  
)

export default component.exports